import { Component, HostListener, Input, OnInit } from '@angular/core';
import { QrGeneratorNavigatorIMAGE } from '@app/store/models/qr-generator-navigator-image.interface';
import { SocialHelper } from '@app/store/models/social-helper.interface';
import { QrGeneratorNavigatorIMAGES } from 'shared-library';
import { CoreService } from 'src/app/modules/core/services/core.service';
import { FunctionsService } from 'src/app/modules/core/services/functions.service';

declare var PhotoSwipe: any
declare var PhotoSwipeUI_Default: any

@Component({
  selector: 'app-qrs-images',
  templateUrl: './qrs-images.component.html',
  styleUrls: ['./qrs-images.component.scss', '../qrs-wrapper.component.scss']
})
export class QrsImagesComponent implements OnInit {

  @Input() qr_url: string;
  @Input() social_data: SocialHelper
  @Input() data: QrGeneratorNavigatorIMAGES

  gallery: any;
  batchSize = 20;
  loading = false;
  galleryElements: Array<HTMLElement> = []
  images: Array<QrGeneratorNavigatorIMAGE> = []

  constructor(
    public readonly coreService: CoreService,
    public readonly functionService: FunctionsService
  ) { }

  ngOnInit(): void {
    this.functionService.initializeTooltip()
    this.loadImages()
    this.initPhotoSwipe()
  }

  private loadImages(): void {
    if (this.images.length === this.data.images.list.length) return
    this.loading = true;
    setTimeout(() => {
      const _currentMainIndex = this.images.length
      for (let index = _currentMainIndex; index < _currentMainIndex + this.batchSize; index++) {
        if (index >= this.data.images.list.length) break
        this.images.push(this.data.images.list[index])
      }
      this.loading = false;
    }, 1000);
  }

  private createGalleryItem(image: QrGeneratorNavigatorIMAGE): HTMLElement {
    // Create figure element
    let figure = document.createElement('figure');
    figure.setAttribute('itemprop', 'associatedMedia');
    figure.setAttribute('itemscope', '');
    figure.setAttribute('data-pswp-uid', image.position.toString());
    figure.setAttribute('itemtype', 'http://schema.org/ImageObject');

    // Create anchor element
    let anchor = document.createElement('a');
    anchor.setAttribute('href', image.url);
    anchor.setAttribute('itemprop', 'contentUrl');
    // anchor.setAttribute('data-size', '600x400');

    // Create image element
    let img = document.createElement('img');
    img.setAttribute('src', image.url);
    img.setAttribute('itemprop', 'thumbnail');
    img.setAttribute('alt', image.name);

    // Append image to anchor
    anchor.appendChild(img);

    // Append anchor and figcaption to figure
    figure.appendChild(anchor);

    // Create figcaption element
    let figcaption = document.createElement('figcaption');
    figcaption.setAttribute('itemprop', image.name);
    figcaption.appendChild(document.createTextNode(image.name));

    // Append figcaption to figure
    figure.appendChild(figcaption);

    // Append figure to the document body (or any other parent element)
    return figure
  }

  private async initPhotoSwipe() {

    // loop through all gallery elements and bind events
    this.galleryElements = this.data.images.list.map(image => this.createGalleryItem(image));

    const photoswipeParseHash = () => {
      const params: any = {};
      const hash = window.location.hash.substring(1)

      if (hash.length < 5) {
        return params;
      }

      let vars = hash.split('&');
      for (let i = 0; i < vars.length; i++) {
        if (!vars[i]) {
          continue;
        }
        let pair = vars[i].split('=');
        if (pair.length < 2) {
          continue;
        }
        params[pair[0]] = pair[1];
      }

      if (params.gid) {
        params.gid = parseInt(params.gid, 10);
      }

      return params;
    };

    // Parse URL and open gallery if it contains #&pid=3&gid=1
    let hashData = photoswipeParseHash();
    if (hashData.pid && hashData.gid) {
      await this.openPhotoSwipe(hashData.pid, this.galleryElements[hashData.gid - 1], true, true);
    }
  }

  openGallery(image: QrGeneratorNavigatorIMAGE, event: Event) {
    event.preventDefault();
    event.stopPropagation();
    const index = this.data.images.list.findIndex(_image => _image.position === image.position)
    if (index >= 0) {
      // open PhotoSwipe if valid index found
      this.openPhotoSwipe(index, this.galleryElements[index]);
    }
  }

  private async openPhotoSwipe(index: number, galleryElement: HTMLElement, disableAnimation = false, fromURL = false) {

    const parseThumbnailElements = async () => {

      interface ItemInterface {
        w: number;
        h: number;
        src: string;
        pid?: number;
        msrc?: string;
        title?: string;
        el?: HTMLElement;
      }

      const items: Array<ItemInterface> = []
      for (let i = 0; i < this.galleryElements.length; i++) {

        const figureEl = this.galleryElements[i]; // <figure> element
        const linkEl = figureEl.children[0]; // <a> element
        let size: Array<string> = linkEl.getAttribute('data-size') ? linkEl.getAttribute('data-size').split('x').map(n => n) : [];

        if (!size.length) {
          const getMeta = async (url: string): Promise<string[]> => {
            return new Promise((y) => {
              var img = new Image();
              img.addEventListener("load", function () {
                linkEl.setAttribute('data-size', `${this.naturalWidth}x${this.naturalHeight}`)
                y([`${this.naturalWidth}`, `${this.naturalHeight}`])
              });
              img.src = url;
            })
          }
          size = await getMeta(linkEl.getAttribute("href"))
        }

        // create slide object
        const item: ItemInterface = {
          src: linkEl.getAttribute('href'),
          w: parseInt(size[0], 10),
          h: parseInt(size[1], 10)
        };

        if (figureEl.children.length > 1) {
          // <figcaption> content
          item.title = figureEl.children[1].innerHTML;
        }

        if (linkEl.children.length > 0) {
          // <img> thumbnail element, retrieving thumbnail url
          item.msrc = linkEl.children[0].getAttribute('src');
        }
        item.el = figureEl; // save link to element for getThumbBoundsFn
        items.push(item);
      }
      return items;
    };

    let items = await parseThumbnailElements();
    let pswpElement = document.querySelectorAll('.pswp')[0];
    // define options (if needed)
    let options: any = {
      loop: false,
      // define gallery index (for URL)
      galleryUID: galleryElement.getAttribute('data-pswp-uid'),

      getNumItemsFn: () => this.data.images.list.length,

      getThumbBoundsFn: (index: number) => {
        // See Options -> getThumbBoundsFn section of documentation for more info
        let thumbnail = items[index].el.getElementsByTagName('img')[0], // find thumbnail
          pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
          rect = thumbnail.getBoundingClientRect();
        return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
      },
    };

    // PhotoSwipe opened from URL
    if (fromURL) {
      if (options.galleryPIDs) {
        // parse real index when custom PIDs are used
        // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
        for (let j = 0; j < items.length; j++) {
          if (items[j].pid == index) {
            options.index = j;
            break;
          }
        }
      } else {
        // in URL indexes start from 1
        options.index = index - 1;
      }
    } else {
      options.index = index;
    }

    // exit if index not found
    if (isNaN(options.index)) {
      return;
    }

    if (disableAnimation) {
      options.showAnimationDuration = 0;
    }

    // Pass data to PhotoSwipe and initialize it
    this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

    this.gallery.next = () => {
      if (this.gallery.options.loop || this.gallery.getCurrentIndex() < this.gallery.options.getNumItemsFn() - 1) {
        {
          if (this.gallery.getCurrentIndex() + this.batchSize / 2 > this.gallery.items.length) {
            this.loadImages()
          }
        }
        this.gallery.goTo(this.gallery.getCurrentIndex() + 1);
      }
    }

    this.gallery.prev = () => {
      if (this.gallery.options.loop || this.gallery.getCurrentIndex() > 0) {
        this.gallery.goTo(this.gallery.getCurrentIndex() - 1);
      }
    }
    this.gallery.init();
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(event: Event): void {
    const windowHeight = 'innerHeight' in window ? window.innerHeight : document.documentElement.offsetHeight;
    const body = document.body;
    const html = document.documentElement;
    const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);

    const windowBottom = windowHeight + window.pageYOffset;

    if (windowBottom >= docHeight - 100 && !this.loading) {
      // Load the next batch of images when scrolled to the bottom
      this.loadImages();
    }

    {
      const element = document.getElementById("back-to-top");
      if (element) {
        if (window.pageYOffset > 1000) {
          element.classList.add("show");
        } else {
          element.classList.remove("show");
        }
      }
    }
  }

}
